import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  snsSiteId: '',
  email: '',
  redirectUrl: '',
  complete: false,
  errorMap: null,
  loading: false,
}

class SnsRelation extends Component {
  state = initialState;

  // 初期表示処理
  componentDidMount() {

    // SNS情報参照
    this.getSnsUserInfo();
  }

  // SNS情報参照
  getSnsUserInfo = () => {

    const { SNS_ASSOCIATE_TID } = this.props.params;

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    try {

    // ローディング開始
    this.setState({ loading: true });

    // SNS情報参照
    axios
      .get( process.env.REACT_APP_URL_CO_SC_API_SNS_USER_INFO,
        {
          params: {
            snsAssociateTid: SNS_ASSOCIATE_TID
          },
          headers: {
            'accept-language': window.changeLang(sessionStorage.getItem("lang")),
            'Cache-Control': 'no-store',
            'Pragma': 'no-cache'
          }
        }
       )
      .then( response => {
        const snsSiteId = response.data.snsSiteId;
        let snsEmail;
        if(snsSiteId === 'line'){
          snsEmail = response.data.email == null ? '' : response.data.email;
        }else{
          snsEmail = response.data.email;
        }
        const email = snsEmail;
        this.setState({
                        snsSiteId: snsSiteId,
                        email: email,
                        errorMap: '',
                        loading: false
                      });
        // GA計測用データレイヤースクリプトを追加する
        window.addDataLayerScript('jmbauth_sns_confirmation');
      })
      .catch( error => {
        if ( error.response ) {
          if ( error.response.status === 403 ) {
            this.setState({ errorMap:
              { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsRelation.M014_errorMessage001 },
              loading: false
              });
          }
          else if ( error.response.status === 500 ) {

            // エラー画面に遷移し、処理を終了する
            this.props.history.push({
              pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
            });
          }
          else {
            this.setState({ errorMap:
              { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsRelation.M014_errorMessage001 },
              loading: false
            });
          }
        }
        else {
          this.setState({ errorMap:
            { ERROR: messageList.snsRelation.M014_errorMessage001 },
            loading: false
            });
        }
        // エラーメッセージ表示領域に遷移する
        window.location="#JS_error";
      })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
      { ERROR: messageList.snsRelation.M014_errorMessage001},
      loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }
  }

  // [連携する]ボタン押下時処理
  snsRelation = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_snsrelation_a", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    const { SNS_ASSOCIATE_TID } = this.props.params;

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    try {
      // ローディング開始
      this.setState({ loading: true });

      // SNS認証紐付けAPI
      axios
        .post( process.env.REACT_APP_URL_CO_SC_API_SNS_ASSOCIATE,
          {
            snsAssociateTid: SNS_ASSOCIATE_TID
          },
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
        .then( response => {
          this.setState({ errorMap: null,
                          redirectUrl: response.data.redirectUrl,
                          complete: true,
                          loading: false
                        });
          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_sns_completion');

          // セッションストレージにSNSログイン情報を削除する
          if (sessionStorage.getItem('SNSLOGIN')) {
            sessionStorage.removeItem('SNSLOGIN')
          }
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsRelation.M014_errorMessage001 },
                loading: false
              });
            }
            else if ( error.response.status === 401 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsRelation.M014_errorMessage001 },
                loading: false
              });
            }
            else if ( error.response.status === 403 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsRelation.M014_errorMessage001 },
                loading: false
              });
            }
            else if ( error.response.status === 500 ) {
              // セッションストレージにSNSログイン情報を削除する
              if (sessionStorage.getItem('SNSLOGIN')) {
                sessionStorage.removeItem('SNSLOGIN')
              }
              // エラーメッセージ表示領域に遷移する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsRelation.M014_errorMessage001 },
                loading: false
              });
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.snsRelation.M014_errorMessage001 },
              loading: false
            });
          }
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        })
    } catch ( err ) {
      console.error(err)
      this.setState({ errorMap:
        { ERROR: messageList.snsRelation.M014_errorMessage001},
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }

  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    console.log(this.state);

    // SNS認証紐付け完了画面
    if (this.state.complete){
      return (
        <section className="content">

          {/* ブラウザタイトル */}
          <Helmet
            title={messageList.snsRelationCompletion.M001_browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.snsRelationCompletion.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <a className="ds-button__trigger" href={this.state.redirectUrl}>
                    <span className="ds-button__label">{messageList.snsRelationCompletion.M003_back}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </section>
      );
    }

    // SNS認証紐付け確認画面
    else{
      return (
        <section className="content">

          {/* ブラウザタイトル */}
          <Helmet
            title={messageList.snsRelation.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.snsRelation.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* ガイド表示部 */}
            <p className="ds-text">{messageList.snsRelation.M003_guideMessage001}</p>
            <a href={messageList.snsRelation.M016_noticeUrl001} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
              {messageList.snsRelation.M004_guideMessage002}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.snsRelation.M005_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>

            <div id="JS_error">
            { // エラーメッセージ表示
            (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.snsRelation.M006_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.snsRelation.M007_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>/* /ds-inlineNote */
            }
            </div>

            {/* SNSロゴ・メールアドレス表示部 */}
            <div className="listLinkage">
              <div className="listLinkage__item">
                <div className="listLinkage__logo">
                  {(this.state.snsSiteId === 'google') &&
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_google.png`} alt={messageList.snsRelation.M008_snsGoogle}/>}
                  {(this.state.snsSiteId === 'yahoo') &&
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_yahoo.png`} alt={messageList.snsRelation.M009_snsYahoo}/>}
                  {(this.state.snsSiteId === 'line') &&
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_line.png`} alt={messageList.snsRelation.M015_snsLine}/>}
                </div>
                <div className="listLinkage__address">{this.state.email}</div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--primary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.snsRelation}>
                    <span className="ds-button__label">{messageList.snsRelation.M010_link}</span>
                  </button>
                </div>
              </div>
              <div className="buttonWrap buttonWrap--left">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <Link className="ds-button__trigger" to="sns_relation_select">
                    <span className="ds-button__label">{messageList.snsRelation.M011_back}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.snsRelation.M012_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              <li className="ds-listText__item">{messageList.snsRelation.M013_notice001}</li>
            </ul>
          </div>

        </section>
      );
    }
  }
}

export default withRouter(SnsRelation)
